module.exports = __webpack_public_path__ + "static/creativeNZ-gold-3633d60f9ced661135e04d7398cb8be9.png";